"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSchema = exports.TimeUnits = void 0;
// export const SearchSchema: Readonly<Record<string, EntitySchema<TSchema>>> = {
//   SourgumOrder: SourgumOrderSchema,
// } as const;
// export type TSearchSchema = typeof SearchSchema;
exports.TimeUnits = ['SECONDS', 'MINUTES', 'HOURS', 'DAYS', 'WEEKS', 'MONTHS', 'YEARS'];
var schema_1 = require("./schema");
Object.defineProperty(exports, "SearchSchema", { enumerable: true, get: function () { return schema_1.SearchSchema; } });
// export const query: Query = {
//   type: 'SourgumOrder',
//   query: { query: 'test', restrictToFields: ['haulerHaulRate'] },
//   filters: [
//     {
//       field: 'status',
//       type: 'STRING',
//       operator: 'IS_IN',
//       value: 'Test',
//     },
//   ],
// };
//# sourceMappingURL=index.js.map